(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/competition-logo.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/competition-logo.js');

'use strict';

const {
  Image
} = svs.content.image_v2;
const {
  resolveCompetitionLogo
} = svs.components.marketplaceCompetition.helpers;
const CompetitionLogo = _ref => {
  let {
    competition
  } = _ref;
  const imageOptions = resolveCompetitionLogo(competition.id);
  return imageOptions && React.createElement(Image, {
    cssSelectors: "logo-image",
    image: imageOptions
  });
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.CompetitionLogo', CompetitionLogo);

 })(window);